'use strict'

// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var raws = ['pre', 'script', 'style', 'textarea']

module.exports = raws



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/constant/html-raw-names.js
// module id = 1512
// module chunks = 0